import React from "react";
// import Header from "../header/Header";
import LandingFooter from "../landingFooter/LandingFooter";
import Header from "../pages/landingPageNew/Header";
const MainLayout = ({ children }) => {
  return (
    <>
      <div className="min-h-screen flex flex-col">
        {/* <Header /> */}
        <Header />

        <div className="flex-grow">{children}</div>

        <LandingFooter />
      </div>
    </>
  );
};

export default MainLayout;
